<div>
    <h5 class="text-start text-primary fw-bold ps-2 ms-1 mt-2 mb-4">Bank Details</h5>

    <div class="row mx-0">
        <!-- <div class="col-lg-4 col-12" *ngIf="getnre">
            <input class="ms-0 form-check-input" name="nre" type="checkbox" id="nre" [(ngModel)]="nre" (change)="typeChange($event)" >
            <label class="form-check-label ps-2" for="nre">PIS NRE Account</label>
            <div class="mt-4" *ngIf="nre">
                <div class="form-floating mt-md-3 mt-3">
                    <input type="text" class="form-control" autocomplete="off" maxlength="24" [(ngModel)]="nreAccountName" [ngClass]="nreAccountName ? 'has-value' : ''" id="nreAccountName" placeholder="Enter NRE Account Holder Name" appAlphabetsOnly>
                    <label for="nreAccountName" class="small ps-0">Account Holder Name as per Bank<span class="text-danger">*</span></label>
                    
                </div>
                <div class="form-floating mt-md-3 mt-3">
                    <input type="text" class="form-control" autocomplete="off" maxlength="24" [(ngModel)]="nreAccountNo" [ngClass]="nreAccountNo ? 'has-value' : ''" id="nreAccountNo" placeholder="Enter NRE Account Number" appDigitOnly>
                    <label for="nreAccountNo" class="small ps-0">Account No.<span class="text-danger">*</span></label>
                    
                </div>
                <div class="ng-autocomplete rounded-2 border form-floating mt-3">
                    <ng-autocomplete #autocomplete
                                [data]="bankIfsc"
                                [searchKeyword]="keyword"
                                (selected)='selectEvent($event,"NREPIS")'
                                (inputChanged)='onChangeSearch($event,"NREPIS")'
                                (inputFocused)='onFocused($event)'
                                (inputCleared)="deletebank('NREPIS')"
                                [itemTemplate]="itemTemplate"
                                [notFoundTemplate]="notFoundTemplate"
                                [(ngModel)]="nreIfscCode">
                            </ng-autocomplete>
                            <label [ngClass]="nreIfscCode ? 'small ps-0 pin-top has-value':'small ps-0'">IFSC Code <span class="text-danger">*</span></label>
                            <ng-template #itemTemplate let-item>
                                <a [innerHTML]="item"></a>
                            </ng-template>
                            
                            <ng-template #notFoundTemplate let-notFound>
                                <div [innerHTML]="notFound"></div>
                            </ng-template>                    

                </div>
                <div class="form-floating mt-3">
                    <select class="form-select rounded-2" [(ngModel)]="nreMicr" id="nreMicr" name="nreMicr" (change)="addressBind(nreMicr,'NREPIS')">
                        <option value="" *ngIf="bankList && bankList.length > 1">Select MICR</option>
                        <option *ngFor="let list of bankList" selected [value]="list.MICRCODE">{{ list.MICRCODE }}</option>
                    </select>
                    <label for="nreMicr" [ngClass]="nreMicr ? 'small ps-0':'form-select-label small ps-0'">MICR Code<span class="text-danger">*</span></label>
                </div>
                <div class="form-floating mt-md-3 mt-3">
                    <input type="text" class="form-control" readonly autocomplete="off" maxlength="24" [(ngModel)]="nreBank" [ngClass]="nreBank ? 'has-value' : ''" appAlphabetsOnly id="nreBank" placeholder="Bank NRE PIS Account">
                    <label for="nreBank" class="small ps-0">Bank Name <span class="text-danger">*</span></label>
                    
                </div>
                
                <div class="form-floating mt-md-3 mt-3 mb-3">
                    <input type="text" class="form-control" autocomplete="off" minlength="5" maxlength="120"
                        [(ngModel)]="branchAddress1" [ngClass]="branchAddress1 ? 'has-value' : ''" id="branchAddress1" placeholder="Address"
                        readonly>
                    <label for="branchAddress1" class="small ps-0">Address<span class="text-danger">*</span></label>
                </div>
                
                <div>
                    <nri-app-img-upld [imageName]="'NRE'" (imageURL)="imageURL($event)" #nrepisimg></nri-app-img-upld>
                    <div class="text-danger small mb-4" *ngIf="nrepisImgempty">
                        Please Upload NRE
                    </div>
                </div>
            </div>
        </div> -->
        <div class="col-lg-4 col-12" *ngIf="getnro">
            <input class="ms-md-0 form-check-input" name="nro" type="checkbox" id="nro" [(ngModel)]="nro"
                (change)="typeChange($event)" [disabled]="NRO1 === 'Y'">
            <label class="form-check-label ps-2" for="nro">NRO (Savings Account)</label>
            <div class="mt-4" *ngIf="nro">

                <div class="form-floating mt-md-3 mt-3">
                    <input [type]="shownreAccount ? 'text' : 'password'" class="form-control"
                        (focus)="shownreAccount = true;" (blur)="shownreAccount = false;checkAccountNumber('NRE');"
                        autocomplete="off" maxlength="24" [(ngModel)]="nroAccountNo"
                        [ngClass]="nroAccountNo ? 'has-value' : ''" id="nroAccountNo" placeholder="Bank NRE PIS Account"
                        appDigitOnly>
                    <label for="nroAccountNo" class="small ps-0">Account No.<span class="text-danger">*</span></label>

                </div>
                <div class="form-floating mt-md-3 mt-3">
                    <input [type]="shownreConAccount ? 'text' : 'password'" class="form-control"
                        (focus)="shownreConAccount = true;"
                        (blur)="shownreConAccount = false;checkAccountNumber('NRE');" autocomplete="off" maxlength="24"
                        [(ngModel)]="confirmnroAccountNo" [ngClass]="confirmnroAccountNo ? 'has-value' : ''"
                        id="confirmnroAccountNo" placeholder="Bank NRE PIS Account" appDigitOnly>
                    <label for="confirmnroAccountNo" class="small ps-0">Confirm Account No.<span
                            class="text-danger">*</span></label>
                    <small class="text-danger ms-2" *ngIf="checkNreAcc">Account Number Must be Same</small>
                </div>
                <div class="ng-autocomplete rounded-2 border form-floating mt-3">
                    <ng-autocomplete [data]="bankIfsc" [searchKeyword]="keyword"
                        (selected)='selectEvent($event,"NRENPIS")' (inputChanged)='onChangeSearch($event,"NRENPIS")'
                        (inputFocused)='onFocused($event)' (inputCleared)="deletebank('NRENPIS')"
                        [itemTemplate]="itemTemplate" [notFoundTemplate]="notFoundTemplate" [(ngModel)]="nroIfscCode">
                    </ng-autocomplete>
                    <label [ngClass]="nroIfscCode ? 'small ps-0 pin-top has-value':'small ps-0'">IFSC Code <span
                            class="text-danger">*</span></label>
                    <ng-template #itemTemplate let-item>
                        <a [innerHTML]="item"></a>
                    </ng-template>

                    <ng-template #notFoundTemplate let-notFound>
                        <div [innerHTML]="notFound"></div>
                    </ng-template>

                </div>
                <div class="form-floating mt-3">
                    <select class="form-select rounded-2" [(ngModel)]="nroMicr" id="nroMicr" name="nroMicr"
                        (change)="addressBind(nroMicr,'NRENPIS')">
                        <option [value]="" *ngIf="bankList1 && bankList1.length > 1">Select MICR</option>
                        <option *ngFor="let list of bankList1" [value]="list.MICRCODE">{{ list.MICRCODE }}</option>
                    </select>
                    <label for="nroMicr" [ngClass]="nroMicr ? 'small ps-0':'form-select-label small ps-0'">MICR
                        Code<span class="text-danger">*</span></label>
                </div>
                <div class="form-floating mt-md-3 mt-3">
                    <input type="text" class="form-control" readonly autocomplete="off" maxlength="24"
                        [(ngModel)]="nroBank" [ngClass]="nroBank ? 'has-value' : ''" id="nroBank"
                        placeholder="Bank NRE NPIS Account" appAlphabetsOnly>
                    <label for="nroBank" class="small ps-0">Bank Name <span class="text-danger">*</span></label>

                </div>

                <div class="form-floating mt-md-3 mt-3 mb-3">
                    <input type="text" class="form-control" autocomplete="off" (input)="validateInput($event,'branch1')"
                        [(ngModel)]="branchName" [ngClass]="branchName ? 'has-value' : ''" id="branchName"
                        placeholder="branchName">
                    <label for="branchName" class="small ps-0">Branch Name<span class="text-danger">*</span></label>
                </div>

                <div class="form-floating mt-md-3 mt-3 mb-3">
                    <input type="text" class="form-control" autocomplete="off" minlength="5" maxlength="120"
                        [(ngModel)]="branchAddress2" [ngClass]="branchAddress2 ? 'has-value' : ''" id="branchAddress2"
                        placeholder="Address" readonly>
                    <label for="branchAddress2" class="small ps-0">Address<span class="text-danger">*</span></label>
                </div>

                <div>
                    <nri-app-img-upld [imageName]="'NRO'" (imageURL)="imageURL($event)" #nrenpisimg></nri-app-img-upld>
                    <div class="text-danger small mb-4" *ngIf="nrenpisImgempty">
                        {{ NRO1 === 'Y' ? 'Please upload bank statement' : 'Please Upload NRO' }}
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="col-lg-3 col-12" *ngIf="getPIS">
            <input class="ms-md-0 form-check-input" name="pis" type="checkbox" id="pis" [(ngModel)]="pis" (change)="typeChange($event)">
            <label class="form-check-label ps-2" for="pis">NRO PIS</label>
            <div class="mt-4" *ngIf="pis">
                
                <div class="form-floating mt-md-3 mt-3">
                    <input type="text" class="form-control" autocomplete="off" maxlength="24" [(ngModel)]="pisAccountNo" [ngClass]="pisAccountNo ? 'has-value' : ''" id="pisAccountNo" placeholder="Bank NRE PIS Account" appDigitOnly>
                    <label for="pisAccountNo" class="small ps-0">Account No.<span class="text-danger">*</span></label>
                   
                </div>
                <div class="ng-autocomplete rounded-2 border form-floating mt-3">
                    <ng-autocomplete
                                [data]="bankIfsc"
                                [searchKeyword]="keyword"
                                (selected)='selectEvent($event,"NROPIS")'
                                (inputChanged)='onChangeSearch($event,"NROPIS")'
                                (inputFocused)='onFocused($event)'
                                (inputCleared)="deletebank('NROPIS')"
                                [itemTemplate]="itemTemplate"
                                [notFoundTemplate]="notFoundTemplate"
                                [(ngModel)]="pisIfscCode">
                            </ng-autocomplete>
                            <label [ngClass]="pisIfscCode ? 'small ps-0 pin-top has-value':'small ps-0'">IFSC Code <span class="text-danger">*</span></label>
                            <ng-template #itemTemplate let-item>
                                <a [innerHTML]="item"></a>
                            </ng-template>
                            
                            <ng-template #notFoundTemplate let-notFound>
                                <div [innerHTML]="notFound"></div>
                            </ng-template>                    

                </div>
                <div class="form-floating mt-3">
                    <select class="form-select rounded-2" [(ngModel)]="pisMicr" id="pisMicr" name="pisMicr" (change)="addressBind(pisMicr,'NROPIS')">
                        <option [value]="" *ngIf="bankList2 && bankList2.length > 1">Select MICR</option>
                        <option *ngFor="let list of bankList2" [value]="list.MICRCODE">{{ list.MICRCODE }}</option>
                    </select>
                    <label for="pisMicr" [ngClass]="pisMicr ? 'small ps-0':'form-select-label small ps-0'">MICR Code<span class="text-danger">*</span></label>
                </div>
                <div class="form-floating mt-md-3 mt-3">
                    <input type="text" class="form-control" readonly autocomplete="off" maxlength="24" [(ngModel)]="pisBank" [ngClass]="pisBank ? 'has-value' : ''" id="pisBank" placeholder="Bank NRO PIS Account" appAlphabetsOnly>
                    <label for="pisBank" class="small ps-0">Bank Name <span class="text-danger">*</span></label>
                    
                </div>
               
                <div class="form-floating mt-md-3 mt-3 mb-3">
                    <input type="text" class="form-control" autocomplete="off" minlength="5" maxlength="24"
                        [(ngModel)]="pisReferenceNo" [ngClass]="pisReferenceNo ? 'has-value' : ''" id="pisReferenceNo" placeholder="RBI Reference No"
                        appDigitOnly>
                    <label for="pisReferenceNo" class="small ps-0">RBI Reference No<span class="text-danger">*</span></label>
                    
                </div>
                <div>
                    <nri-app-img-upld [imageName]="'NRO_PIS'" (imageURL)="imageURL($event)" #nropisimg></nri-app-img-upld>
                    <div class="text-danger small mb-4" *ngIf="nropisImgempty">
                        Please Upload NRO PIS 
                    </div>
                </div>
            </div>
        </div> -->
        <div class="col-lg-4 col-12" *ngIf="getNonPIS && NRO1 !=='Y'">
            <input class="ms-md-0 form-check-input" name="nonPis" type="checkbox" id="nonPis" [(ngModel)]="nonPis"
                (change)="typeChange($event)">
            <label class="form-check-label ps-2" for="nonPis">NON PIS NRE (Savings Account )</label>
            <div class="mt-4" *ngIf="nonPis">
                <div class="form-floating mt-md-3 mt-3">
                    <input [type]="shownroAccount ? 'text' : 'password'" class="form-control"
                        (focus)="shownroAccount = true;" (blur)="shownroAccount = false;checkAccountNumber('NRO')"
                        autocomplete="off" maxlength="24" [(ngModel)]="nonPisAccountNo"
                        [ngClass]="nonPisAccountNo ? 'has-value' : ''" id="nonPisAccountNo"
                        placeholder="Bank NRE PIS Account" appDigitOnly>
                    <label for="nonPisAccountNo" class="small ps-0">Account No.<span
                            class="text-danger">*</span></label>
                    <small class="text-danger ms-2" *ngIf="bothAccountErr">
                        NRO and NRE AccNo cannot be same.
                    </small>
                </div>
                <div class="form-floating mt-md-3 mt-3">
                    <input [type]="shownroConAccount ? 'text' : 'password'" class="form-control" autocomplete="off"
                        (focus)="shownroConAccount = true;"
                        (blur)="shownroConAccount = false;checkAccountNumber('NRO');" maxlength="24"
                        [(ngModel)]="confirmnonPisAccountNo" [ngClass]="confirmnonPisAccountNo ? 'has-value' : ''"
                        id="nonPisAccountNo" placeholder="Bank NRE PIS Account" appDigitOnly>
                    <label for="confirmnonPisAccountNo" class="small ps-0">Confirm Account No.<span
                            class="text-danger">*</span></label>
                    <small class="text-danger ms-2" *ngIf="checkNroAcc">Account Number Must be same.</small>
                </div>
                <div class="ng-autocomplete rounded-2 border form-floating mt-3">
                    <ng-autocomplete [data]="bankIfsc" [searchKeyword]="keyword"
                        (selected)='selectEvent($event,"NRONPIS")' (inputChanged)='onChangeSearch($event,"NRONPIS")'
                        (inputFocused)='onFocused($event)' (inputCleared)="deletebank('NRONPIS')"
                        [itemTemplate]="itemTemplate" [notFoundTemplate]="notFoundTemplate"
                        [(ngModel)]="nonPisIfscCode">
                    </ng-autocomplete>
                    <label [ngClass]="nonPisIfscCode ? 'small ps-0 pin-top has-value':'small ps-0'">IFSC Code <span
                            class="text-danger">*</span></label>
                    <ng-template #itemTemplate let-item>
                        <a [innerHTML]="item"></a>
                    </ng-template>

                    <ng-template #notFoundTemplate let-notFound>
                        <div [innerHTML]="notFound"></div>
                    </ng-template>

                </div>
                <div class="form-floating mt-3">
                    <select class="form-select rounded-2" [(ngModel)]="nonPisMicr" id="nonPisMicr" name="nonPisMicr"
                        (change)="addressBind(nonPisMicr,'NRONPIS')">
                        <option [value]="" class="" *ngIf="bankList3 && bankList3.length > 1">Select MICR</option>
                        <option *ngFor="let list of bankList3" [value]="list.MICRCODE">{{ list.MICRCODE }}</option>
                    </select>
                    <label for="nonPisMicr" [ngClass]="nonPisMicr ? 'small ps-0':'form-select-label small ps-0'">MICR
                        Code<span class="text-danger">*</span></label>
                </div>

                <div class="form-floating mt-md-3 mt-3">
                    <input type="text" class="form-control" readonly autocomplete="off" maxlength="24" id="nonPisBank"
                        [(ngModel)]="nonPisBank" [ngClass]="nonPisBank ? 'has-value' : ''"
                        placeholder="Bank NRO NPIS Account" appAlphabetsOnly>
                    <label for="nonPisBank" class="small ps-0">Bank Name<span class="text-danger">*</span></label>
                    <!-- <div class="text-danger small my-4" *ngIf="nronpisacError">
                        Please provide Bank Name
                    </div> -->
                </div>
                <!-- <div class="form-floating mt-md-3 mt-3">
                    <input type="text" class="form-control" autocomplete="off" maxlength="24" [(ngModel)]="nonPisMicr" [ngClass]="nonPisMicr ? 'has-value' : ''" id="nonPisMicr" placeholder="Bank NRE PIS Account" appDigitOnly>
                    <label for="nonPisMicr" class="small ps-0">MICR Code <span class="text-danger">*</span></label>
                   
                </div> -->
                <!-- <div class="form-floating mt-md-3 mt-3">
                    <input type="text" class="form-control" autocomplete="off" maxlength="24" [(ngModel)]="nonPisIfscCode" [ngClass]="nonPisIfscCode ? 'has-value' : ''" id="nonPisIfscCode" placeholder="Bank NRE PIS Account" appAlphanumeric>
                    <label for="nonPisIfscCode" class="small ps-0">IFSC Code <span class="text-danger">*</span></label>
                   
                </div> -->
                <div class="form-floating mt-md-3 mt-3 mb-3">
                    <input type="text" class="form-control" autocomplete="off" (input)="validateInput($event,'branch2')"
                        [(ngModel)]="branchName1" [ngClass]="branchName1 ? 'has-value' : ''" id="branchName1"
                        placeholder="branchName1">
                    <label for="branchName1" class="small ps-0">Branch Name<span class="text-danger">*</span></label>
                </div>
                <div class="form-floating mt-md-3 mt-3 mb-3">
                    <input type="text" class="form-control" autocomplete="off" minlength="5" maxlength="120"
                        [(ngModel)]="branchAddress3" [ngClass]="branchAddress3 ? 'has-value' : ''" id="branchAddress3"
                        placeholder="Address" readonly>
                    <label for="branchAddress3" class="small ps-0">Address<span class="text-danger">*</span></label>
                </div>
                <!-- <div class="form-floating mt-md-3 mt-3 mb-3">
                    <input type="text" class="form-control" autocomplete="off" minlength="5" maxlength="24"
                        [(ngModel)]="nonPisReferenceNo" [ngClass]="nonPisReferenceNo ? 'has-value' : ''" id="nonPisReferenceNo" placeholder="RBI Reference No"
                        appDigitOnly>
                    <label for="nonPisReferenceNo" class="small ps-0">RBI Reference No<span class="text-danger">*</span></label>              
                </div> -->
                <div>
                    <nri-app-img-upld [imageName]="'NON_PIS'" (imageURL)="imageURL($event)"
                        #nronpisimg></nri-app-img-upld>
                    <div class="text-danger small mb-4" *ngIf="nronpisImgempty">
                        Please Upload NONPIS
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="row mx-0" *ngIf="NRO ==='Y'">
        <div class="col-lg-12 col-12 " *ngIf="getnro">
            <input class="ms-md-0 form-check-input" name="nro" type="checkbox" id="nro" [(ngModel)]="nro"
                (change)="typeChange($event)" disabled="NRO ==='Y'"/>
            <label class="form-check-label ps-2" for="nro">NRO (Savings Account)</label>

            <div class="mt-4" *ngIf="nro">
                <div class="row">
                    <div class="col-md-6 pe-lg-5 pe-md-2 ps-md-2 px-0">
                        <div class="form-floating mt-3 mb-md-4">
                            <input [type]="shownreAccount ? 'text' : 'password'" class="form-control"
                                (focus)="shownreAccount = true;"
                                (blur)="shownreAccount = false;checkAccountNumber('NRE');" autocomplete="off"
                                maxlength="24" [(ngModel)]="nroAccountNo" [ngClass]="nroAccountNo ? 'has-value' : ''"
                                id="nroAccountNo" placeholder="Bank NRE PIS Account" appDigitOnly />
                            <label for="nroAccountNo" class="small ps-0">Account No.<span
                                    class="text-danger">*</span></label>
                        </div>
                    </div>

                    <div class="col-md-6 pe-lg-5 pe-md-2 ps-md-2 px-0">
                        <div class="form-floating mt-3 mb-md-4">
                            <input [type]="shownreConAccount ? 'text' : 'password'" class="form-control"
                                (focus)="shownreConAccount = true;"
                                (blur)="shownreConAccount = false;checkAccountNumber('NRE');" autocomplete="off"
                                maxlength="24" [(ngModel)]="confirmnroAccountNo"
                                [ngClass]="confirmnroAccountNo ? 'has-value' : ''" id="confirmnroAccountNo"
                                placeholder="Bank NRE PIS Account" appDigitOnly />
                            <label for="confirmnroAccountNo" class="small ps-0">Confirm Account No.<span
                                    class="text-danger">*</span></label>
                            <small class="text-danger ms-2" *ngIf="checkNreAcc">Account Number Must be Same</small>
                        </div>
                    </div>

                    <div class="col-md-6 pe-lg-5 pe-md-2 ps-md-2 px-0">
                        <div class="ng-autocomplete rounded-2 border form-floating mt-3">
                            <ng-autocomplete [data]="bankIfsc" [searchKeyword]="keyword"
                                (selected)='selectEvent($event,"NRENPIS")'
                                (inputChanged)='onChangeSearch($event,"NRENPIS")' (inputFocused)='onFocused($event)'
                                (inputCleared)="deletebank('NRENPIS')" [itemTemplate]="itemTemplate"
                                [notFoundTemplate]="notFoundTemplate" [(ngModel)]="nroIfscCode">
                            </ng-autocomplete>
                            <label [ngClass]="nroIfscCode ? 'small ps-0 pin-top has-value':'small ps-0'">
                                IFSC Code <span class="text-danger">*</span>
                            </label>
                            <ng-template #itemTemplate let-item>
                                <a [innerHTML]="item"></a>
                            </ng-template>
                            <ng-template #notFoundTemplate let-notFound>
                                <div [innerHTML]="notFound"></div>
                            </ng-template>
                        </div>
                    </div>

                    <div class="col-md-6 pe-lg-5 pe-md-2 ps-md-2 px-0">
                        <div class="form-floating mt-3 mb-md-4">
                            <select class="form-select rounded-2" [(ngModel)]="nroMicr" id="nroMicr" name="nroMicr"
                                (change)="addressBind(nroMicr,'NRENPIS')">
                                <option [value]="" *ngIf="bankList1 && bankList1.length > 1">Select MICR</option>
                                <option *ngFor="let list of bankList1" [value]="list.MICRCODE">{{ list.MICRCODE }}
                                </option>
                            </select>
                            <label for="nroMicr" [ngClass]="nroMicr ? 'small ps-0':'form-select-label small ps-0'">
                                MICR Code<span class="text-danger">*</span>
                            </label>
                        </div>
                    </div>

                    <div class="col-md-6 pe-lg-5 pe-md-2 ps-md-2 px-0">
                        <div class="form-floating mt-3 mb-md-4">
                            <input type="text" class="form-control" readonly autocomplete="off" maxlength="24"
                                [(ngModel)]="nroBank" [ngClass]="nroBank ? 'has-value' : ''" id="nroBank"
                                placeholder="Bank NRE NPIS Account" appAlphabetsOnly />
                            <label for="nroBank" class="small ps-0">Bank Name <span class="text-danger">*</span></label>
                        </div>
                    </div>

                    <div class="col-md-6 pe-lg-5 pe-md-2 ps-md-2 px-0">
                        <div class="form-floating mt-3 mb-md-4">
                            <input type="text" class="form-control" autocomplete="off"
                                (input)="validateInput($event,'branch1')" [(ngModel)]="branchName"
                                [ngClass]="branchName ? 'has-value' : ''" id="branchName" placeholder="branchName" />
                            <label for="branchName" class="small ps-0">Branch Name<span
                                    class="text-danger">*</span></label>
                        </div>
                    </div>

                    <div class="col-md-6 pe-lg-5 pe-md-2 ps-md-2 px-0">
                        <div class="form-floating mt-3 mb-md-4">
                            <input type="text" class="form-control" autocomplete="off" minlength="5" maxlength="120"
                                [(ngModel)]="branchAddress2" [ngClass]="branchAddress2 ? 'has-value' : ''"
                                id="branchAddress2" placeholder="Address" readonly />
                            <label for="branchAddress2" class="small ps-0">Address<span
                                    class="text-danger">*</span></label>
                        </div>
                    </div>

                     <div class="row mx-0">
                         <div class="col-md-6">
                        <nri-app-img-upld [imageName]="'NRO'" (imageURL)="imageURL($event)"
                            #nrenpisimg></nri-app-img-upld>
                        <div class="text-danger small mb-4" *ngIf="nrenpisImgempty">
                            Please Upload NRO
                        </div>
                    </div>
                     </div>
                   
                </div>
            </div>
        </div>
    </div> -->


    <!-- <div class="row mx-0" *ngIf="nrePIS || nreNPIS">
        <h5 class="text-start text-primary fw-bold ps-2 ms-1 mt-4">Enter RBI Reference Number</h5>
        <div class="col-lg-4 col-12">
            <div class="form-floating mt-md-3 mt-3 ms-ms-2">
                <input type="text" class="form-control" autocomplete="off" minlength="5" maxlength="24"
                    [(ngModel)]="referenceNo" id="referenceNo" placeholder="RBI Reference No"
                    appDigitOnly (blur)="spaceValidation($event, 'nrepis')">
                <label for="referenceNo" class="small ps-0">RBI Reference No<span class="text-danger">*</span></label>
                <div class="text-danger small my-4" *ngIf="referenceNoErrorMsg">
                    Please provide RBI Reference Number
                </div>
            </div>
        </div>
    </div> -->
    <div class="d-flex align-items-end mx-0 mt-5 pt-5 row">
        <div class="col-6 p-0">
            <button class="btn btn-white border-primary text-primary px-4" (click)="backStage()">Back</button>
        </div>
        <div class="col-6 text-end p-0 pe-md-3">
            <button class="btn btn-primary px-4" [disabled]="(!nre && !nro && !pis && !nonPis)"
                (click)="stageValidate()">Next</button>
        </div>
    </div>
</div>
<ngx-ui-loader></ngx-ui-loader>
<app-error-modal #errorComp></app-error-modal>